// ---------------------------------------------------------------
// avatarColor.js — Color propio y estable para cada persona.
// Se calcula a partir de su nombre/uid (siempre el mismo color para
// la misma persona) sin guardar nada ni pedir datos: coste cero.
// ---------------------------------------------------------------
// Paleta viva: cada persona se distingue de un vistazo en los
// avatares y en la línea de tiempo del día.
const PALETTE = [
  "#0071e3", // azul
  "#8b5cf6", // violeta
  "#ec4899", // rosa
  "#f59e0b", // ámbar
  "#10b981", // verde
  "#06b6d4", // turquesa
  "#ef4444", // rojo
  "#6366f1", // índigo
  "#14b8a6", // teal
  "#d946ef", // fucsia
];

/** Color fijo de una persona (por username o uid) */
export function avatarColor(key = "") {
  const s = String(key || "");
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return PALETTE[h % PALETTE.length];
}

/** Estilo listo para poner en el <div className="avatar"> */
export function avatarStyle(key) {
  const c = avatarColor(key);
  return {
    "--avatar-color": c,
    "--avatar-color-2": `color-mix(in srgb, ${c} 65%, #fff)`,
  };
}
